import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

interface WizardHeaderProps {
  title: string;
  step: number; // zero-based
  totalSteps: number;
  showStepBadge?: boolean;
}

export const WizardHeader: React.FC<WizardHeaderProps> = ({
  title,
  step,
  totalSteps,
  showStepBadge = true,
}) => (
  <>
    <Box display="flex" alignItems="center" justifyContent="space-between" px={3} pt={3} pb={2}>
      <Typography variant="h6" fontWeight={600}>
        {title}
      </Typography>
      {showStepBadge && (
        <Box
          sx={{
            bgcolor: "primary.main",
            color: "primary.contrastText",
            borderRadius: 999,
            px: 1.5,
            py: 0.25,
            fontSize: 12,
            fontWeight: 600,
            minWidth: 36,
            textAlign: "center",
          }}
        >
          {step + 1} / {totalSteps}
        </Box>
      )}
    </Box>
    <Divider />
  </>
);
